<template>
  <v-container class="px-5">
    <v-row>
      <v-col
        cols="12"
        lg="9"
      >
        <h5>
          {{ $t('stepper.order.basic') }}
        </h5>
      </v-col>
      <v-col
        cols="12"
        lg="9"
      >
        <v-row>
          <v-col cols="12">
            <label class="input-label">{{ $t('labels.claimType') }} *</label>
            <span>{{ claimTypeDescription }}</span>
            <custom-item-group
              :selected="order.basicInformation.claimType"
              :items="claimTypes"
              :translation="'claimType'"
              :validator="$root.$v.order.basicInformation.claimType"
              @update:selected="$root.updateOrder('claimType', $event); $root.updateOrder('isValid', !$root.$v.order.basicInformation.$anyError);"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <custom-input-group
              :model="order.basicInformation.customerNr"
              :validator="$root.$v.order.basicInformation.customerNr"
              :maxlength="21"
              label="customerNr"
              @update:model="$root.updateOrder('customerNr', $event)"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <custom-input-group
              :model="order.basicInformation.information"
              :validator="$root.$v.order.basicInformation.information"
              :maxlength="256"
              label="additionalInformation"
              @update:model="$root.updateOrder('information', $event)"
            />
          </v-col>
          <v-col
            class="text-center"
            cols="12"
          >
            <v-btn
              large
              tile
              class="primary"
              to="/order/debtor"
            >
              {{ $t('common.continue') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    computed: {
      order () {
        return this.$store.getters.order
      },
      claimTypes () {
        return this.$store.getters.claimTypes
      },
      claimTypeDescription () {
        return this.order.basicInformation.claimType !== '' ? this.$t('claimtypeDescription.' + this.order.basicInformation.claimType) : ''
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.$root.$v.order.basicInformation.$anyDirty) {
        this.$root.$v.order.basicInformation.$touch()
      }
      next()
    }
  }
</script>
